import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateWrapper = ({ children }) => {
  const location = useLocation();
  const { user, isAuthLoading, needsOnboarding } = useAuth();

  console.log('PrivateWrapper:', user);

  if (isAuthLoading ) {
    return (
      <div className="flex justify-center items-center h-screen bg-background">
        <div className="w-8 h-8 border-4 border-muted border-t-primary rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    console.log('PrivateWrapper: Not authenticated');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (needsOnboarding && location.pathname !== '/onboarding') {
    console.log('PrivateWrapper: Needs onboarding');
    return <Navigate to="/onboarding" replace />;
  }

  return children;
};

export default PrivateWrapper;
